/**
 * 手动埋点label
 */
export const enum ELogLabel {
  // 切换语言
  TRIGGER_LANGUAGE = 'TRIGGER_LANGUAGE',
}

/**
 * 触发手动日志记录
 * @param label - 日志标签，用于区分不同的日志类型或来源
 * @param data - 可选参数，用于记录额外的日志信息
 * 
 * 尝试调用全局的 Bishop 对象的 log 方法来记录日志
 * 如果 Bishop 对象不存在或者 log 方法调用失败，函数会将错误进行输出
 */
export function triggerManualLog(label: string, data?: string | number | Date) {
  try {
    window.Bishop?.log(label, data);
  } catch (err) {console.error(`Failed to log: ${err}`);}
}